import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteIncomeInformation: Map<string, ConfirmationData> = new Map([
    ["ddd1b2e5-84ef-42c6-8b1f-2d5e251a75d7", { hidden: true }],
]);



